export class StateInfo {
    constructor(public readonly state: string, public readonly count: number) {
        
    }

    getColor = (): string => {
        switch (this.state) {
            case 'OLD':
                return '#808080';
            case 'MTS':
                return '#32CD32';
            case 'MTO':
                return '#FF0000';
            case 'OUT':
                return '0000FF';
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/assortment-structure/state-info.ts